import { useEffect } from 'react';

function useKeyPressWithCallback(targetKey, cb = () => void 0) {
  useEffect(() => {
    function downHandler({ key }) {
      if (key === targetKey) {
        cb();
      }
    }
    window.addEventListener("keydown", downHandler);
    return () => {
      window.removeEventListener("keydown", downHandler);
    };
  }, [cb, targetKey]);
}

export { useKeyPressWithCallback };
//# sourceMappingURL=useKeyPressWithCallback.es.js.map
